// import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4'
import { ANALYTICS_HELPER, HELPER, LocalStorageService } from '../../utils'
import { store } from '../../store'

function initializeGA() {
	// ReactGA.initialize(process.env.REACT_APP_ANALYTICS_ID);
	// ReactGA.plugin.require('ec');

	ReactGA4.initialize(process.env.REACT_APP_MEASUREMENT_ID)
}

function initializebShop() {
	GOOGLE_ANALYTICS_HELPER.appShift(
		ANALYTICS_HELPER.EVENT_STEPS.SHOP,
		ANALYTICS_HELPER.CATEGORY.SHOP
	)
	return true
}

function setPageView(location) {
	// ReactGA.set({ page: location });
	// ReactGA.pageview(location);

	ReactGA4.send({ hitType: 'pageview', page: location, title: location })
}

function appShift(step, name) {
	let _event = { step: step, option: name }
	// ReactGA.plugin.execute('ec', 'setAction', 'checkout', _event);
	// ReactGA.plugin.execute('ec', 'setAction', 'checkout_option', _event);

	ReactGA4.event('checkout', _event)
	ReactGA4.event('checkout_option', _event)
	return true
}

function createEvent(SUB_EVENT, properties) {
	const action = properties?.action
	const label = properties?.label

	delete properties.action
	delete properties.label

	window.bSecure.push({
		event: SUB_EVENT,
		eventProps: {
			category: SUB_EVENT,
			action,
			label,
			value: {
				nonInteraction: false,
			},
		},
	})

	let _event = {
		category: SUB_EVENT,
		action,
		label,
		nonInteraction: false,
	}
	// ReactGA.event(_event);
	ReactGA4.event(_event)

	return true
}

/**
 *
 * PRODUCT FLOW
 *
 */

function productImpressions(itemList) {
	const state = store.getState()
	const { currency_code } = state.config.merchant
	let productItems = []
	if (!HELPER.isEmpty(itemList)) {
		itemList.map((items) => {
			const { selected_category, active_variants } = items
			selected_category.map((category) => {
				active_variants.map((variant) => {
					productItems.push({
						id: items?.id,
						name: items?.name,
						price: variant?.discounted_price,
						quantity: variant?.max_quantity,
						category: category,
						list_name: 'Search Results',
						variant: variant?.variant_name,
						list_position: items?.key,
						//
						item_id: items?.id,
						item_name: items?.name,
						item_variant: variant?.variant_name,
						item_category: category,
						index: items?.key,
						currency: currency_code,
					})
					return true
				})
				return true
			})
			return true
		})
		// ReactGA.plugin.execute('ec', 'addImpression', {
		//   currencyCode: currency_code,
		//   impressions: productItems,
		// });
		// ReactGA.plugin.execute('ec', 'setAction', 'addImpression', {
		//   currencyCode: currency_code,
		//   impressions: productItems,
		// });

		ReactGA4.event('view_item_list', {
			items: productItems,
		})

		if (window.bSecure) {
			window.bSecure.push({
				ecommerce: {
					currencyCode: currency_code,
					impressions: productItems,
				},
			})
		}

		let transactionId = Math.random().toString(36).substring(2) + new Date().getTime().toString(36)
		LocalStorageService._updateInSessionStorage('transaction_id', transactionId)
		window.bSecure.push({
			event: 'checkoutOption',
			transactionProducts: productItems,
			ecommerce: {
				checkout: {
					actionField: { id: transactionId, step: 1, option: ANALYTICS_HELPER.CATEGORY.SHOP },
					currencyCode: currency_code,
					products: productItems,
					checkout_options: [
						{ step: ANALYTICS_HELPER.EVENT_STEPS.SHOP, option: ANALYTICS_HELPER.CATEGORY.SHOP },
						{ step: ANALYTICS_HELPER.EVENT_STEPS.LOGIN, option: ANALYTICS_HELPER.CATEGORY.LOGIN },
						{
							step: ANALYTICS_HELPER.EVENT_STEPS.SELLER_LIST,
							option: ANALYTICS_HELPER.CATEGORY.SELLER_LIST,
						},
						{
							step: ANALYTICS_HELPER.EVENT_STEPS.PRODUCT_DETAIL,
							option: ANALYTICS_HELPER.CATEGORY.PRODUCT_DETAIL,
						},
					],
				},
			},
		})
	}
	return true
}

/**
 * Call this function when a user clicks on a product link. This function uses the event
 * callback datalayer variable to handle navigation after the ecommerce data has been sent
 * to Google Analytics.
 * @param {Object} product An object representing a product.
 */
function productClick(product) {
	// ReactGA.plugin.execute('ec', 'setAction', 'click', product);
	ReactGA4.event('select_item', {
		items: [
			{
				item_name: product.name,
				item_id: product.id,
				price: product.price,
				position: product.position,
				index: product.position,
				item_variant: product.variant,
			},
		],
	})
	return null
}

/**
 * Call this function when a user clicks on a product link. This function uses the event
 * callback datalayer variable to handle navigation after the ecommerce data has been sent
 * to Google Analytics.
 * @param {Object} product An object representing a product.
 */
function productDetail(product) {
	// ReactGA.plugin.execute('ec', 'setAction', 'detail', product);

	ReactGA4.event('view_item', {
		items: [
			{
				item_name: product.name,
				item_id: product.id,
				price: product?.selected_variant?.discounted_price ?? product.price,
				item_brand: product.product_store,
				item_category: product.selected_category[0] ? product.selected_category[0] : '',
				item_variant: product?.selected_variant?.variant_name,
			},
		],
	})
	return true
}

function productPurchase(purchase) {
	// ReactGA.plugin.execute('ec', 'setAction', 'purchase', purchase);
	// ReactGA.plugin.execute('ec', 'setAction', 'addTransaction', addTransaction);
	// ReactGA.plugin.execute('ec', 'clear');

	const _purchase = {
		items: purchase?.products?.map((e) => ({
			item_name: e.name,
			item_id: e.id,
			price: e?.price,
			sku: e.sku,
			item_brand: e.sku,
			item_category: e.category,
			item_variant: e?.variant,
		})),
		transcation_id: purchase?.transaction_id,
		affiliation: purchase?.affiliation,
		revenue: purchase?.revenue,
		shipping: purchase?.shipping,
		currency: purchase?.currency,
		value: purchase?.value,
	}
	ReactGA4.event('purchase', _purchase)
	return true
}

/**
 *
 * CART FLOW
 *
 */

function cartAdd(product, qty, selected_category) {
	// ReactGA.plugin.execute('ec', 'setAction', 'addProduct', {
	//   id: product?.id,
	//   name: product?.name,
	//   price: product?.discounted_price,
	//   quantity: qty,
	//   category: selected_category?.name,
	//   variant: product?.selected_variant?.variant_name,
	//   // "brand": "Kiosk",
	//   // "dimension1": "M",
	// });
	// ReactGA.plugin.execute('ec', 'addProduct', {
	//   id: product?.id,
	//   name: product?.name,
	//   price: product?.discounted_price,
	//   quantity: qty,
	//   category: selected_category?.name,
	//   variant: product?.selected_variant?.variant_name,
	//   // "brand": "Kiosk",
	//   // "dimension1": "M",
	// });
	// ReactGA.plugin.execute('ec', 'setAction', 'add');

	let _obj = {
		items: [
			{
				item_id: product?.id,
				item_name: product?.name,
				price: product?.selected_variant?.discounted_price ?? product?.discounted_price,
				quantity: isNaN(qty) ? 1 : qty,
				item_category: product.selected_category[0] ?? selected_category?.name,
				item_variant: product?.selected_variant?.variant_name,
			},
		],
	}
	ReactGA4.event('add_to_cart', _obj)

	let _event = {
		category: ANALYTICS_HELPER.CATEGORY.CART,
		action: 'Add item to cart',
		label: 'Add item to cart',
		nonInteraction: false,
	}
	// ReactGA.event(_event);
	ReactGA4.event(_event)
	return true
}

function cartRemove(product, qty, category) {
	// ReactGA.plugin.execute('ec', 'setAction', 'addProduct', {
	//   id: product?.id,
	//   name: product?.name,
	//   price: product?.discounted_price,
	//   quantity: qty,
	//   category: category,
	//   variant: product?.selected_variant?.variant_name,
	//   // "brand": "Kiosk",
	//   // "dimension1": "M",
	// });
	// ReactGA.plugin.execute('ec', 'addProduct', {
	//   id: product?.id,
	//   name: product?.name,
	//   price: product?.discounted_price,
	//   quantity: qty,
	// });
	// ReactGA.plugin.execute('ec', 'setAction', 'remove');

	let _obj = {
		items: [
			{
				item_id: product?.id,
				item_name: product?.name,
				price: product?.selected_variant?.discounted_price ?? product?.discounted_price,
				quantity: isNaN(qty) ? 1 : qty,
				item_category: product.selected_category[0] ?? category?.name,
				item_variant: product?.selected_variant?.variant_name,
			},
		],
	}
	ReactGA4.event('add_to_cart', _obj)

	let _event = {
		category: ANALYTICS_HELPER.CATEGORY.CART,
		action: 'Remove item from cart',
		label: 'Remove item from cart',
		nonInteraction: false,
	}
	// ReactGA.event(_event);
	ReactGA4.event(_event)
	return true
}

const GOOGLE_ANALYTICS_HELPER = {
	initializeGA,
	initializebShop,
	setPageView,
	appShift,
	createEvent,

	productImpressions,
	productClick,
	productDetail,
	productPurchase,

	cartAdd,
	cartRemove,
}

export default GOOGLE_ANALYTICS_HELPER
